import styled from 'styled-components';

const OptionsContainer = styled.label`
    padding: 0;
    margin: 0;
    margin-right: 15px;
    font-family: inherit;
    font-size: 0.86em;
    cursor: pointer;
    display: flex;
    flex-direction: row;
`;

export default OptionsContainer;



// WEBPACK FOOTER //
// ./app/containers/FastCover/components/OptionsContainer/index.js